<mat-card class="question-card">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.minAnswers" [innerHTML]="minAnswersErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.maxAnswers" [innerHTML]="maxAnswersErrorMessage"></div>
      </mat-error>
    </div>
    <div [formGroup]="form">
      <div [formGroup]="ctrl">
        <div class="docs-component-category-list multiImage">
          <a *ngFor="let category of inputData; let i = index" class="docs-component-category-list-item">
            <mat-checkbox color="primary" [formControl]="getCtrl(category.code)" [value]="category.code"
              (click)="clickHandler(category.code, $event)">
              <mat-card class="docs-component-category-list-card" style="    height: 296px !important;
                      width: 320px !important;" (click)="fixImageSelectedId(category)"
                [style.background-color]="category.imageSelected ? '#00897b' : 'white'">
                <mat-card-content class="docs-component-category-list-card-summary">
                  <img mat-card-image [src]="category.imagePath" class="imagerounded" alt="" />
                  <div
                    style="background-color: #00897b;color: white;padding-left: 10px;padding-right: 10px; text-align: center;text-overflow: ellipsis;overflow: hidden;"
                    matTooltip="{{category.imageName}}">
                    <span>
                      {{category.imageName}}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-checkbox>
          </a>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>